export const legalDefaults = {
  privacyPolicy: {
    title: "Privacy Policy",
    lastUpdated: "July 2026",
    sections: [
      {
        heading: "Information We Collect",
        body: "We collect information you provide when contacting us, donating, subscribing to our newsletter, or volunteering — including name, email, phone number, and message content.",
      },
      {
        heading: "How We Use Your Information",
        body: "Your information is used to respond to inquiries, process donations, send updates about our programs, and improve our services. We do not sell your personal data to third parties.",
      },
      {
        heading: "Data Security",
        body: "We implement appropriate technical and organizational measures to protect your personal information. Payment processing is handled securely through Razorpay; we do not store card details.",
      },
      {
        heading: "Contact",
        body: "For privacy-related questions, contact us.",
      },
    ],
  },
  termsOfService: {
    title: "Terms of Service",
    lastUpdated: "July 2026",
    sections: [
      {
        heading: "Acceptance of Terms",
        body: "By accessing and using the AJA Abhaya Hastham Foundation website, you agree to these Terms of Service.",
      },
      {
        heading: "Donations",
        body: "All donations are voluntary and non-refundable except as required by applicable law. Donation receipts are issued in accordance with applicable tax regulations.",
      },
      {
        heading: "Intellectual Property",
        body: "Content on this website, including text, images, and logos, is the property of AJA Abhaya Hastham Foundation and may not be reproduced without permission.",
      },
      {
        heading: "Limitation of Liability",
        body: "We strive to keep information accurate but make no warranties about completeness. Use of this website is at your own risk.",
      },
    ],
  },
} as const;

/** @deprecated Use getLegalContent() from @/lib/legal-content */
export const legal = legalDefaults;
